import { render, staticRenderFns } from "./CMOverviewCourseWeekRow.vue?vue&type=template&id=3b44586c&scoped=true&lang=pug"
import script from "./CMOverviewCourseWeekRow.vue?vue&type=script&lang=js"
export * from "./CMOverviewCourseWeekRow.vue?vue&type=script&lang=js"
import style0 from "./CMOverviewCourseWeekRow.vue?vue&type=style&index=0&id=3b44586c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b44586c",
  null
  
)

export default component.exports